import type { SpecialAreaCard } from '@store/selectors/monitor.selectors';
import type { IReplayView } from './buildReplayView';

/**
 * The special areas at the playhead, in the live cards' shape. The live cards lend
 * the list, the names and the moving flag; everything about who was there comes from
 * the replay. The archive does not record a hoist's fixed floor, so it shows none.
 */
export function replaySpecialAreaCards(liveCards: readonly SpecialAreaCard[], view: IReplayView): SpecialAreaCard[] {
  return liveCards.map((card) => {
    const floor = view.chipsByFloor.get(card.floorId);
    const managers = view.managersByFloor.get(card.floorId) ?? [];
    const equipment = view.equipmentByFloor.get(card.floorId) ?? [];
    return {
      ...card,
      workersCount: floor?.workersCount ?? 0,
      professionChips: floor?.chips ?? [],
      hasOperator: managers.length > 0,
      operatorName: managers[0]?.name ?? null,
      equipmentCount: equipment.reduce((total, item) => total + item.count, 0),
      alertsCount: view.rail.safetyRows.filter((row) => row.floorLabel === card.name).length,
      currentFloorLabel: null,
    };
  });
}
